var map = {
	"./background.png": 55,
	"./background.svg": 56,
	"./contact.jpg": 57,
	"./flags/be.svg": 58,
	"./flags/cn.svg": 59,
	"./flags/de.svg": 60,
	"./flags/es.svg": 61,
	"./flags/fr.svg": 62,
	"./flags/gb.svg": 63,
	"./flags/it.svg": 64,
	"./flags/jp.svg": 65,
	"./flags/us.svg": 66,
	"./grainy_bg.jpg": 67,
	"./icons/back.svg": 68,
	"./icons/close.svg": 69,
	"./icons/error.svg": 70,
	"./icons/facebook.svg": 71,
	"./icons/info.svg": 72,
	"./icons/information.svg": 73,
	"./icons/instagram.svg": 74,
	"./icons/linkedin.svg": 75,
	"./icons/marker.svg": 76,
	"./icons/pinterest.svg": 77,
	"./icons/slider-arrow.svg": 78,
	"./icons/success.svg": 79,
	"./icons/twitter.svg": 80,
	"./icons/weibo.svg": 81,
	"./icons/youtube.svg": 82,
	"./logo.png": 83,
	"./logo.svg": 84
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54;